var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row border-bottom"},[_c('div',{staticClass:"col"},[_c('span',{staticClass:"h5"},[_vm._v(_vm._s(_vm.title))])]),_c('div',{staticClass:"col"},[(_vm.required)?_c('p',{staticClass:"text-right body-1"},[_c('span',{staticClass:"red"},[_vm._v("*")]),_vm._v(" Indicates a required field.")]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }